import React, { useState } from 'react';
import { List } from 'antd';
import ReportDoc from '../../../components/ReportDoc/ReportDoc';
import { useNavigate } from 'react-router-dom';

const Emp = (props) => {

    const navigate = useNavigate();

    const [data] = useState([
        {
            id: 1,
            name: 'Хувь хүний мэдээлэл',
            path: 'personalinformation'
        },
        {
            id: 2,
            name: 'Гэр бүл',
            path: 'family'
        },
        {
            id: 3,
            name: 'Хөгжлийн бэрхшээл',
            path: 'disability'
        }
    ]);

    const onPressNode = (p_item) => {
        navigate('/hrsuite/report/empbasic/emp/' + p_item.path);
    }

    const renderItem = (item) => {
        return (
            <ReportDoc data={item} onClick={onPressNode} />
        );
    }

    return (
        <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
            <List
                grid={{
                    gutter: [0, 16]
                }}
                dataSource={data}
                renderItem={renderItem}
            />
        </div>
    );
}

export default Emp;